import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/home/Events/Events.tsx");
